import { memo } from 'react';

import LegacyCalculationIcon from './LegacyCalculationIcon';
import LegacyInputIcon from './LegacyInputIcon';

interface LegacyIndicatorIconProperties {
  indicatorType: string | undefined;
  size?: number;
}

const iconStyle = { margin: '0 6px', flexShrink: 0 } as const;

const LEGACY_CALCULATION_COLOR = '#4BB6B9';
const LEGACY_INPUT_COLOR = '#9C89DD';

/** Input/calculation icons for legacy Builder Mode tables only. */
const LegacyIndicatorIcon = memo(({ indicatorType, size = 20 }: LegacyIndicatorIconProperties) => {
  const normalizedType = indicatorType?.toLowerCase() ?? '';

  if (normalizedType === 'calculation') {
    return (
      <LegacyCalculationIcon
        width={size}
        height={size}
        color={LEGACY_CALCULATION_COLOR}
        style={iconStyle}
      />
    );
  }

  if (normalizedType === 'input') {
    return (
      <LegacyInputIcon width={size} height={size} color={LEGACY_INPUT_COLOR} style={iconStyle} />
    );
  }

  return null;
});

LegacyIndicatorIcon.displayName = 'LegacyIndicatorIcon';

export default LegacyIndicatorIcon;
